import { defineComponent, createElementBlock, openBlock, createCommentVNode, createElementVNode, normalizeClass, toDisplayString } from "vue";
const _hoisted_1 = { class: "receipt-divider" };
const _hoisted_2 = {
  key: 0,
  class: "divider-lines"
};
const _hoisted_3 = {
  key: 0,
  class: "divider-line"
};
const _hoisted_4 = {
  key: 2,
  class: "divider-lines"
};
const _hoisted_5 = {
  key: 0,
  class: "divider-line"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ReceiptDivider",
  props: {
    text: {
      type: String,
      default: null
    },
    delimiter: {
      type: String,
      default: "-"
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        ["-", "="].includes(__props.delimiter) ? (openBlock(), createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = createElementVNode("div", { class: "divider-line" }, null, -1)),
          ["="].includes(__props.delimiter) ? (openBlock(), createElementBlock("div", _hoisted_3)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        __props.text ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["divider-text", { "large": __props.large }])
        }, toDisplayString(__props.text), 3)) : createCommentVNode("", true),
        ["-", "="].includes(__props.delimiter) ? (openBlock(), createElementBlock("div", _hoisted_4, [
          _cache[1] || (_cache[1] = createElementVNode("div", { class: "divider-line" }, null, -1)),
          ["="].includes(__props.delimiter) ? (openBlock(), createElementBlock("div", _hoisted_5)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index11.js.map
